<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <span class="title-h4 mr-r10">예측 자원 목록</span>
        <el-select  class="mr-r4" style="width: 100px;" v-model="objDefineId">
          <el-option v-for="(item, index) in objDefineList" :key="index" :label="item.objDefineName" :value="item.objDefineId"></el-option>
        </el-select>
        <el-popover placement="bottom" trigger="click" v-model="showEventPopover">
          <el-row class="title-bar" type="flex" justify="end">
            <w-header-search-button size="mini" @click="popoverShowSearchTool = !popoverShowSearchTool"></w-header-search-button>
          </el-row>
          <el-scrollbar class="bar-visible">
            <el-table-wrapper style="height: 400px; width: 400px;" ref="popoverTable" v-loading="loading" :columns="targetObjColumn" :data="setTargetObjList"  @condition-change="loadPopoverRscTable"
            row-class-name="c-pointer" :show-search-tool="popoverShowSearchTool" :show-custom-header="true" :pagination="true" @cell-click="selectTargetObjInfo"  remote :total="objTotal">
            </el-table-wrapper>
          </el-scrollbar>
          <el-input class="c-pointer mr-r4" @click.native="clickInputButton" style="width:200px;" slot="reference" v-model="selectedEventHistLabel" placeholder="장비 선택" readonly>
            <i slot="suffix" v-if="selectedEventHistLabel !== null"
              class="el-input__icon el-icon-circle-close el-input__clear"
              @click="clickClearable"></i>
          </el-input>
        </el-popover>
        <el-button size="mini" :disabled="isScheduling" @click="showEditTargetPopup" class="mr-r4">자원 설정</el-button>
        <el-button size="mini" :disabled="!isAbleDeleteRsc || isScheduling" class="mr-r4" @click="deleteRsc">자원 삭제</el-button>
        <el-button size="mini" :disabled="predictRscTableData.length < 1 || isScheduling" @click="showPeriodPopup" class="mr-r4">주기 설정</el-button>
        <span class="text-em  mr-l4">
          {{scheduleFlag && scheduleFlag == 'Y' ? `다음 수행 일시: ${convertPredictDatetime(predictRscTableData[0].predictDatetime)}` : '장애 예측 분석 스케줄이 설정되어 있지 않습니다.'}}
        </span>
      </div>
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <div class="mr-t15">
      <el-table-wrapper :data="predictRscTableData" :columns="predictRscColumns" ref="predictSetTable" @selection-change="changeHandleSelection"
        remote :total="total" :pagination="true" style="width:100%;" :show-search-tool="showSearchTool" :show-custom-header="true" @condition-change="loadPredictAnalysis">
      </el-table-wrapper>
    </div>
    <w-predict-analysis-schedule-setting-popup @reload="reload" ref="predictAnalysisScheduleSettingPopup"></w-predict-analysis-schedule-setting-popup>
    <w-predict-analysis-rsc-setting-popup @reload="reload" ref="predictAnalysisRscSettingPopup"></w-predict-analysis-rsc-setting-popup>
  </div>
</template>
<script>
import { isNil, isEmpty } from 'lodash';
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import EventRptApi from '@/api/event/event-rpt';
import moment from 'moment';
import WPredictAnalysisScheduleSettingPopup from './popup/PredictAnalysisScheduleSettingPopup';
import WPredictAnalysisRscSettingPopup from './popup/PredictAnalysisRscSettingPopup';

export default {
  name: 'WPredictAnalysisSetting',
  components: {
    WPredictAnalysisScheduleSettingPopup,
    WPredictAnalysisRscSettingPopup,
  },
  data() {
    return {
      predictRscTableData: [],
      showSearchTool: false,
      selectedList: [],
      scheduleContent: '',
      nextSchedule: '',
      objDefineList: [],
      objDefineId: null,
      showEventPopover: false,
      popoverShowSearchTool: false,
      loading: false,
      objTotal: 0,
      setTargetObjList: [],
      targetObjParams: {},
      selectedEventHistLabel: null,
      total: 0,
      scheduleFlag: null,
      isScheduling: false,
      predictRscColumns: [
        {
          type: 'selection',
        },
        {
          prop: 'objName',
          label: '장비',
          remoteProp: 'o.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'managetypeName',
          label: '관리 구분',
          remoteProp: 'm.managetype_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rsctypeName',
          label: '자원 구분',
          remoteProp: 'rt.rsctype_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원',
          remoteProp: 'r.rsc_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscKeyName',
          label: '자원키',
          remoteProp: 'ork.rsc_key_name',
          sortable: true,
          searchable: true,
        },
      ],
      targetObjColumn: [
        {
          prop: 'objDefineName',
          label: '관리 구분',
          remoteProp: 'obj.obj_define_name',
          sortable: true,
          searchable: true,
          width: 100,
        },
        {
          prop: 'objName',
          label: '장비명',
          remoteProp: 'obj.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    isAbleDeleteRsc() {
      return !isEmpty(this.selectedList) && this.selectedList.length > 0;
    },
  },
  watch: {
    objDefineId: {
      handler(value) {
        if (!isNil(value)) {
          this.showEventPopover = false;
          this.targetObjParams.objId = null;
          if (value === 'all') {
            this.targetObjParams.objDefineId = null;
          } else {
            this.targetObjParams.objDefineId = value;
          }
          this.loadPredictAnalysis();
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 관련 데이터 loadData 함수
     * @author Song
     */
    loadData() {
      this.loadObjDefineTargetData();
      this.loadPopoverRscTable();
      this.getEventRptScheduleStats(); // 스케줄 상태 확인
    },
    /**
     * 관련 데이터 재로드 함수
     * @author Song
     */
    reload() {
      this.loadPredictAnalysis();
      this.loadObjDefineTargetData();
      this.loadPopoverRscTable();
    },
    // 임계치 가이드 컴포넌트 사용 - 검색 필터링 컴포넌트
    loadObjDefineTargetData() {
      EventRptApi.getEventRptTargetObjDefine().then((response) => {
        if (response.data.success) {
          const objDefineList = [];
          const result = response.data.data;
          objDefineList.push({ objDefineName: '전체', objDefineId: 'all' });
          this.objDefineList = objDefineList.concat(result);
          this.objDefineId = this.objDefineList[0].objDefineId;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '예측 자원 관리 구분 목록', false));
        }
      });
    },
    // 검색 필터링 컴포넌트 (임계치 가이드 컴포넌트 참고)
    loadPopoverRscTable() {
      const tableParams = this.$refs.popoverTable.getParameter();
      const params = {
        objDefineId: this.targetObjParams.objDefineId,
        ...tableParams,
      };
      EventRptApi.getEventRptTargetObjInfo(params).then((response) => {
        if (response.data.success) {
          this.setTargetObjList = response.data.data;
          this.objTotal = response.data.total;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '예측 자원 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '예측 자원 목록', false));
        throw new Error(e);
      });
    },
    // 검색 필터링 컴포넌트 - 선택 이벤트
    selectTargetObjInfo(row) {
      this.showEventPopover = false;
      this.targetObjParams.objId = row.objId;
      this.targetObjParams.objDefineId = row.objDefineId;
      this.selectedEventHistLabel = `[${getValueAfterCheckEmpty(row.objName)}] ${getValueAfterCheckEmpty(row.ipaddress)}`;
      this.loadPredictAnalysis();
    },
    // 검색 필터링 컴포넌트 - 검색 초기화 함수
    clickClearable() {
      if (!isNil(this.selectedEventHistLabel)) {
        this.targetObjParams.objId = null;
        this.targetObjParams.objDefineId = (this.objDefineId === 'all') ? null : this.objDefineId;
        this.selectedEventHistLabel = null;
        this.loadPredictAnalysis();
      }
    },
    /**
     * 장애 예측 분석 자원을 조회한다.
     * @author Song
     */
    loadPredictAnalysis() {
      this.$nextTick(() => {
        const tableParams = this.$refs.predictSetTable.getParameter();
        const params = {
          ...this.targetObjParams,
          ...tableParams,
        };
        // 예측 분석 자원 조회 api
        EventRptApi.getPredictRptTargetRscList(params).then((res) => {
          if (res.data.success) {
            this.predictRscTableData = res.data.data;
            this.total = res.data.total;
            this.scheduleFlag = this.predictRscTableData.length > 0 ? this.predictRscTableData[0].scheduleRepeatFlag : null;
            // this.isDisabledSave = true;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '예측 분석 자원', false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '예측 분석 자원', false));
        });
      });
    },
    /**
     * 장애 예측 분석 주기(스케줄) 팝업
     * @author Song
     */
    showPeriodPopup() {
      this.$refs.predictAnalysisScheduleSettingPopup.open(this.predictRscTableData[0]);
    },
    /**
     * 장애 예측 분석 자원 수정 팝업
     * @author Song
     */
    showEditTargetPopup() {
      this.$refs.predictAnalysisRscSettingPopup.open(this.predictRscTableData[0]);
    },
    /**
     * 장애 예측 분석 자원을 삭제한다.
     * @author Song
     */
    deleteRsc() {
      const deleteList = this.selectedList;
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        EventRptApi.deleteEventRptRscList(deleteList).then((response) => {
          if (response.data.success) {
            this.targetObjParams.objDefineId = (this.objDefineId === 'all') ? null : this.objDefineId;
            this.reload();
            this.$refs.predictAnalysisRscSettingPopup.reload();
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '예측 분석 자원', true));
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '예측 분석 자원', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '예측 분석 자원', false));
          throw new Error(e);
        });
      });
    },
    /**
     * 체크박스 테이블 선택
     * @author Song
     */
    changeHandleSelection(rows) {
      this.selectedList = rows;
    },
    clickInputButton() {
      this.loadPopoverRscTable();
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * predict_datetime = 토요일마다 실행이지만 자바 시간 차이로 + 1일 더해서 값을 추가하도록한다. 하지만 UI에선 실제 토요일로 표현하도록 한다 (2020.03.25 - BE 피드백 - Song)
     * @author Song
     */
    convertPredictDatetime(date) {
      return getDateToString(moment(date).subtract(1, 'days').toDate());
    },
    /**
     * 장애 예측 분석 스케줄이 돌고 있는지 판단한다. 돌고 있을 경우 자원, 주기 설정을 disabled한다.
     * @author Song
     */
    getEventRptScheduleStats() {
      // 토요일에만 해당 api를 조회하며, 토요일은 기존 이벤트예측 스케줄이 돌지않고 오직 장애예측(rpt)만 수행한다. (BE협의)
      const addedWeekCount = 6 - moment(new Date()).day();
      if (addedWeekCount === 0) {
        EventRptApi.getEventRptScheduleStatus().then((res) => {
          if (res.data.success) {
            const scheduleStatus = res.data.data;
            // seqNumber = 장애 예측 자원 최대 seqNumber
            // syncSeqNumber = table_seq 테이블의 값 (현재 수행한 장애예측자원 seqNumber)
            this.isScheduling = scheduleStatus.seqNumber !== scheduleStatus.syncSeqNumber;
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/event/components/PredictAnalysisSetting.vue